/* global axios */

import ApiClient from './ApiClient';

class InteractiveShortcut extends ApiClient {
  constructor() {
    super('interactive_shortcuts', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create({ short_code: shortCode, interactive_payload: interactivePayload, headerImageFile }) {
    if (headerImageFile) {
      const formData = new FormData();
      formData.append('interactive_shortcut[short_code]', shortCode);
      formData.append(
        'interactive_shortcut[interactive_payload]',
        JSON.stringify(interactivePayload || {})
      );
      formData.append('header_image', headerImageFile);
      return axios.post(this.url, formData);
    }

    return super.create({
      interactive_shortcut: {
        short_code: shortCode,
        interactive_payload: interactivePayload,
      },
    });
  }

  update(id, { short_code: shortCode, interactive_payload: interactivePayload, headerImageFile }) {
    if (headerImageFile) {
      const formData = new FormData();
      formData.append('interactive_shortcut[short_code]', shortCode);
      formData.append(
        'interactive_shortcut[interactive_payload]',
        JSON.stringify(interactivePayload || {})
      );
      formData.append('header_image', headerImageFile);
      return axios.patch(`${this.url}/${id}`, formData);
    }

    return super.update(id, {
      interactive_shortcut: {
        short_code: shortCode,
        interactive_payload: interactivePayload,
      },
    });
  }
}

export default new InteractiveShortcut();
